import { fetchAuthSessionWithLogout } from '@/features/auth/lib/authSession';
import { toast } from "react-toastify";

// Base API utility function to handle common API operations
export const makeApiCall = async ({
  endpoint,
  path,
  data,
  method = 'POST',
  requiresAuth = true,
  customHeaders = {},
  successStatusCodes = [200, 201],
  errorMessage = "Operation failed. Please try again.",
  skipErrorToast = false
}) => {
  try {
    const baseEndpoint = endpoint || import.meta.env.VITE_AWS_API_ENDPOINT;
    const url = `${baseEndpoint}${path}`;
    
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;

    const headers = {
      ...customHeaders,
      ...(isFormData
        ? {}
        : {
            'Content-Type':
              customHeaders['Content-Type'] ||
              customHeaders['content-type'] ||
              'application/json',
          }),
    };

    if (requiresAuth) {
      const accessToken = await fetchAuthSessionWithLogout();
      if (!accessToken) {
        return { success: false, error: new Error('No access token available') };
      }
      headers['Authorization'] = `Bearer ${accessToken.toString()}`;
    }

    const config = {
      method,
      headers
    };

    if (data && method !== 'GET') {
      config.body = isFormData ? data : JSON.stringify(data);
    }

    const response = await fetch(url, config);
    
    // Handle different response types
    if (response.headers.get('content-type')?.includes('application/json') || method === 'POST') {
      const responseData = await response.json();
      
      if (successStatusCodes.includes(responseData.statusCode) || (response.ok && !responseData.error)) {
        return { success: true, data: responseData, response };
      } else {
        throw new Error(responseData.error || responseData.message || `Request failed with status ${responseData.statusCode || response.status}`);
      }
    } else {
      // For non-JSON responses
      if (response.ok) {
        return { success: true, response };
      } else {
        throw new Error(`Request failed with status ${response.status}: ${response.statusText}`);
      }
    }
  } catch (error) {
    console.error(`API Error (${path}):`, error);
    if (!skipErrorToast && errorMessage) {
      toast.error(errorMessage);
    }
    return { success: false, error };
  }
};

